import type { ReactNode } from 'react';

/** A big, thumb-sized action (≥64px high): main step buttons and home tiles. */
export function BigButton({
  icon,
  children,
  hint,
  onClick,
  disabled,
  tone = 'primary',
  done,
  label,
}: {
  icon?: ReactNode;
  children: ReactNode;
  hint?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  tone?: 'primary' | 'plain';
  done?: boolean;
  /** Accessible name (screen readers, tests): the visible title plus its state, e.g. «Забрав тіло — Зроблено · 12 жовт.». */
  label?: string;
}) {
  const cls =
    tone === 'primary'
      ? 'bg-acc text-acc-fg border-transparent'
      : 'bg-card text-fg border-line';
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      className={`flex min-h-big w-full items-center gap-4 rounded-2xl border px-5 py-3 text-left text-[18px] font-semibold transition-opacity active:opacity-80 disabled:cursor-not-allowed disabled:opacity-50 ${cls}`}
    >
      {icon ? <span className="flex-none">{icon}</span> : null}
      <span className="min-w-0 flex-1">
        <span className="block">{children}</span>
        {hint ? <span className={`block text-[14px] font-normal ${done ? 'text-ok' : 'opacity-80'}`}>{hint}</span> : null}
      </span>
      {done ? <span className="flex-none text-[22px] text-ok" aria-hidden>✓</span> : null}
    </button>
  );
}

/** Home screen tile: a count and a label, a whole-card link target. */
export function Tile({ value, label, onClick }: { value: number | string; label: string; onClick?: () => void }) {
  return (
    <button type="button" onClick={onClick} className="card flex min-h-[96px] flex-col items-start justify-between text-left active:bg-hov">
      <span className="text-[32px] font-bold leading-none">{value}</span>
      <span className="text-[15px] text-txt">{label}</span>
    </button>
  );
}
